import { useSchedulingQuery as useQuery } from "../../../../hooks/ReactQueryHooks/useSchedulingQuery";
import { getAppointment } from "../../../api/Scheduling/appointments";

export function useReferralAppointment(referral) {
  const appointmentId = referral?.targetAppointment?.reference?.replace(/^Appointment\//, "");
  return useQuery(["scheduling-appointments", "referral", referral?.orgId, appointmentId], async ({ signal, consistency }) => {
    const result = await getAppointment({ organizationRef: referral.orgId, appointmentId, signal, consistency });
    const appointment = result?.appointment;
    if (!appointment || appointment.organizationRef !== referral.orgId ||
        `Encounter/${appointment.bookingContext?.sourceEncounterId}` !== referral.encounter?.reference ||
        !appointment.patients?.some(p => p.role === "subject" && `Patient/${p.patientRef}` === referral.subject?.reference))
      throw new Error("The referral appointment could not be verified.");
    return appointment;
  }, { enabled: referral?.schedulingVersion === 2 && !!appointmentId && !!referral?.orgId, retry: false });
}
